<template>
  <div>
    <search-common-type @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          type="primary"
          @click="showNewModal"
          v-if="isShowMenu('common_types/new')"
        >新增</a-button>

        <update-effective
          v-if="isShowMenu('common_types/effective')"
          :selected-row-keys="selectedRowKeys"
          @completed="fetchData"
        />
      </a-space>
    </div>

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      row-key="id"
    >
      <span slot="actions" slot-scope="text, record">
        <a-space>
          <a @click="showEditModal(record.id)" v-if="isHasEditPermission">编辑</a>
        </a-space>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <!-- 新增模态框 -->
    <new-common-type
      v-if="isShowNewModal"
      :visible.sync="isShowNewModal"
      @completed="fetchData"
    />

    <!-- 编辑模态框 -->
    <edit-common-type
      v-if="isShowEditModal"
      :visible.sync="isShowEditModal"
      :id="editingId"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findCommonTypes } from '@/api/common_type'
import Pagination from '@/components/Pagination'
import SearchCommonType from '@/views/common_types/Search'

export default {
  name: 'CommonTypeList',
  components: {
    Pagination,
    SearchCommonType,
    EditCommonType: () => import('@/views/common_types/Edit'),
    NewCommonType: () => import('@/views/common_types/New'),
    UpdateEffective: () => import('@/views/common_types/UpdateEffective')
  },
  data() {
    return {
      data: [],
      columns: [
        {
          title: '类型',
          dataIndex: 'type',
          width: 200
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 200,
          scopedSlots: { customRender: 'name' }
        },
        {
          title: 'Slug',
          dataIndex: 'sub_type_slug',
          width: 160
        },
        {
          title: '关联上级',
          dataIndex: 'parent_name',
          width: 160
        },
        {
          title: '状态',
          dataIndex: 'effective',
          width: 100
        },
        {
          title: '说明',
          ellipsis: true,
          dataIndex: 'description',
          width: 250
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' }
        }
      ],
      loading: true,
      isShowEditModal: false, // 是否显示编辑表单弹窗
      isShowNewModal: false, // 是否显示新增表单弹窗
      editingId: 0, // 正在编辑的记录id
      selectedRowKeys: [],
      pagination: {
        total_count: 0
      },
      query: { effective: '1' }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    isHasEditPermission() {
      return hasPermission('common_types/edit')
    }
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    isShowMenu(menu) {
      return hasPermission(menu)
    },

    showNewModal() {
      this.isShowNewModal = true
    },

    showEditModal(id) {
      this.editingId = id
      this.isShowEditModal = true
    },

    submitSearch(search) {
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findCommonTypes(Object.assign({}, this.query)).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      })
    }
  }
}
</script>
